/**
 * 联系表单配置
 * apiUrl 生产环境使用同域 /api/contact，由 server/index.js 处理
 */
export default {
  recipientEmail: 'joesguichang@gmail.com',
  apiUrl: '/api/contact',
}



// WEBPACK FOOTER //
// ./src/config/contact.js